/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/import-whitelist
import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';

export const useOrgId = (): { data: string | undefined } => {
	const orgId = getMeta('ajs-org-id');
	return { data: orgId || undefined };
};
